export default __webpack_public_path__ + "static/media/bars.4f91d22e.svg";